import {
  call,
  put,
  takeEvery,
  takeLeading,
  all,
  take,
  fork,
} from "redux-saga/effects";
import userAPI from "../../../../user/api/UserAPI";
import {
  FETCH_USER_IMPC_SELECTIONS_REQUEST,
  DELETE_USER_IMPC_SELECTION_REQUEST,
  FETCH_USER_OPERATOR_SELECTIONS_REQUEST,
  DELETE_USER_OPERATOR_SELECTION_REQUEST,
} from "../../../../user/redux/actions/types/UserActionTypes";
import {
  fetchUserIMPCSelectionsFailureActionCreator,
  fetchUserIMPCSelectionsSuccessActionCreator,
  deleteUserImpcSelectionFailureActionCreator,
  deleteUserImpcSelectionSuccessActionCreator,
  fetchUserOperatorSelectionsSuccessActionCreator,
  fetchUserOperatorSelectionsFailureActionCreator,
  deleteUserOperatorSelectionSuccessActionCreator,
  deleteUserOperatorSelectionFailureActionCreator,
} from "../../../../user/redux/actions/UserActions";
import { postPostalOperatorsImpc } from "../../api/PostalOperatorsApi";
import {
  retrieveOutboundPostalOperatorsFailureActionCreator,
  retrieveOutboundPostalOperatorsSuccessActionCreator,
} from "../actions/DeparturePostalOperatorActions";
import {
  retrieveInboundPostalOperatorsFailureActionCreator,
  retrieveInboundPostalOperatorsSuccessActionCreator,
} from "../actions/ArrivalPostalOperatorActions";
import { RETRIEVE_OUTBOUND_POSTAL_OPERATOR_REQUEST } from "../actions/types/DeparturePostalOperatorActionTypes";
import { RETRIEVE_INBOUND_POSTAL_OPERATOR_REQUEST } from "../actions/types/ArrivalPostalOperatorActionTypes";
import DirectionTypes from "../../../../common/redux/actions/types/DirectionTypes";

function* retrieveOutboundPostalOperatorWorker(action) {
  const stretch =
    action.payload.defaultDirection === DirectionTypes.OUTBOUND
      ? "INBOUND"
      : "OUTBOUND";
  try {
    const postalOperatorsResponse = yield call(postPostalOperatorsImpc, {
      stretch,
      startDate: action.payload.startDate,
      endDate: action.payload.endDate,
    });

    yield put(
      retrieveOutboundPostalOperatorsSuccessActionCreator(
        postalOperatorsResponse.data
      )
    );
  } catch (error) {
    yield put(retrieveOutboundPostalOperatorsFailureActionCreator(error));
  }
}

function* retrieveInboundPostalOperatorWorker(action) {
  const stretch =
    action.payload.defaultDirection === DirectionTypes.INBOUND
      ? "INBOUND"
      : "OUTBOUND";
  try {
    const postalOperatorsResponse = yield call(postPostalOperatorsImpc, {
      stretch,
      startDate: action.payload.startDate,
      endDate: action.payload.endDate,
    });

    yield put(
      retrieveInboundPostalOperatorsSuccessActionCreator(
        postalOperatorsResponse.data
      )
    );
  } catch (error) {
    yield put(retrieveInboundPostalOperatorsFailureActionCreator(error));
  }
}

function* fetchUserIMPCSelectionsWorker(action) {
  try {
    const postalOperatorType = action.payload;

    const userIMPCSelectionsResponse = yield call(
      userAPI.getUserIMPCSelections,
      postalOperatorType
    );
    const selections = userIMPCSelectionsResponse.data;
    yield put(
      fetchUserIMPCSelectionsSuccessActionCreator(
        postalOperatorType,
        selections
      )
    );
  } catch (error) {
    yield put(fetchUserIMPCSelectionsFailureActionCreator(error));
  }
}

function* fetchUserOperatorSelectionsWorker(action) {
  try {
    const postalOperatorType = action.payload;

    const userOperatorSelectionsResponse = yield call(
      userAPI.getUserOperatorSelections,
      postalOperatorType
    );
    const selections = userOperatorSelectionsResponse.data;
    yield put(
      fetchUserOperatorSelectionsSuccessActionCreator(
        postalOperatorType,
        selections
      )
    );
  } catch (error) {
    yield put(fetchUserOperatorSelectionsFailureActionCreator(error));
  }
}

function* deleteUserIMPCSelectionsWorker(action) {
  try {
    yield call(userAPI.deleteUserIMPCSelection, action.payload);
    yield put(deleteUserImpcSelectionSuccessActionCreator());
  } catch (error) {
    yield put(deleteUserImpcSelectionFailureActionCreator(error));
  }
}

function* deleteUserOperatorSelectionsWorker(action) {
  try {
    yield call(userAPI.deleteUserOperatorSelection, action.payload);
    yield put(deleteUserOperatorSelectionSuccessActionCreator());
  } catch (error) {
    yield put(deleteUserOperatorSelectionFailureActionCreator(error));
  }
}

function* watchFetchUserIMPCSelections() {
  const inProgress = {};

  while (true) {
    const action = yield take(FETCH_USER_IMPC_SELECTIONS_REQUEST);
    const operatorType = action.payload;

    if (!inProgress[operatorType]) {
      inProgress[operatorType] = true;

      yield fork(function* executeIMPCFetch() {
        try {
          yield call(fetchUserIMPCSelectionsWorker, action);
        } finally {
          inProgress[operatorType] = false;
        }
      });
    }
  }
}

function* watchFetchUserOperatorSelections() {
  const inProgress = {};

  while (true) {
    const action = yield take(FETCH_USER_OPERATOR_SELECTIONS_REQUEST);
    const operatorType = action.payload;

    if (!inProgress[operatorType]) {
      inProgress[operatorType] = true;

      yield fork(function* executeOperatorFetch() {
        try {
          yield call(fetchUserOperatorSelectionsWorker, action);
        } finally {
          inProgress[operatorType] = false;
        }
      });
    }
  }
}

function* postalOperatorsWatcher() {
  yield all([
    takeLeading(
      RETRIEVE_OUTBOUND_POSTAL_OPERATOR_REQUEST,
      retrieveOutboundPostalOperatorWorker
    ),
    takeLeading(
      RETRIEVE_INBOUND_POSTAL_OPERATOR_REQUEST,
      retrieveInboundPostalOperatorWorker
    ),
    fork(watchFetchUserIMPCSelections),
    fork(watchFetchUserOperatorSelections),
    takeEvery(
      DELETE_USER_IMPC_SELECTION_REQUEST,
      deleteUserIMPCSelectionsWorker
    ),
    takeEvery(
      DELETE_USER_OPERATOR_SELECTION_REQUEST,
      deleteUserOperatorSelectionsWorker
    ),
  ]);
}

export default postalOperatorsWatcher;
